export enum MusicAudioType {
	MOH = 3, // Music on Hold
	VM = 6, // Voice Mail
	MOF = 8, // Music on Forward
}
